<template>
	<div class="follow_up">
		<base-card title="随访计划" headerBorder>
			<div class="follow_up_content mt-28">
				<template v-if="nextDateObj.followUpDate">
					<!-- <div  v-if="dataList.length === 0" class="title text-center">暂无随访计划</div> -->
					<template>
						<div class="title"
							>下一次随访时间：{{ $moment(nextDateObj.followUpDate).format('YYYY年MM月DD日') }}</div
						>
						<div class="label">医生将在每月对您进行一次随访，请您按时完成随访</div>
					</template>
				</template>
				<template v-else>
					<div class="follow_up_null">
						<div>
							<div class="title">暂无随访计划</div>
							<div class="label">请完善基本信息生成随访计划</div>
							<div class="button" @click="$router.push(`/health/base/${patientId}`)">去完善</div>
						</div>
					</div>
				</template>
			</div>
		</base-card>
		<base-card title="随访记录" class="mt-28">
			<van-cell-group v-if="list.length>0">
				<van-cell
					v-for="item in list"
					:key="item.id"
					:title="$moment(item.followUpDate).format('YYYY-MM-DD')"
					is-link
					@click="goDetail(item)"
					class="follow_up_list_item"
				>
					<template #default>
						<span
							:class="`text-${[2,4].indexOf(item.reviewStatus)>-1?'primary':''}`"
							>{{ status[item.reviewStatus] }}</span
						>
					</template>
				</van-cell>
			</van-cell-group>
			<van-empty v-else description="暂无记录" />
		</base-card>
	</div>
</template>
<script>
export default {
    name: 'followUpList',
    data () {
        return {
            dataList: [],
            status: {
                1: '未填写',
                4: '医生已反馈',
                2: '已完成',
                3: '失访'
            },
            nextDateObj: {}
        }
    },
    computed: {
        patientId () {
            return this.$route.params.id
        },
        info () {
            return this.$store.getters['account/patientInfo']
        },
        // nextDateObj () {
        //     return this.dataList.length > 0 ? this.dataList[0] : {}
        // },
        // .slice(1, this.dataList.length)
        list () {
            return this.dataList
        }
    },
    created () {
        this.getFollowUpList()
        this.getFollowUpNewDate()
    },
    methods: {
        getFollowUpList () {
            this.$api.followUp.getFollowUpList({
                page: 1,
                limit: 9999,
                patientId: this.patientId,
                questionnaireTypes: '4,5',
                isShow: 1
            }).then(({ code, data }) => {
                if (!code) {
                    this.dataList = data.list
                }
            })
        },
        getFollowUpNewDate () {
            this.$api.followUp.getFollowUpNewDate({
                patientId: this.patientId,
                questionnaireTypeList: [4, 5],
                isShow: 0
            }).then(({ code, data }) => {
                if (!code) {
                    this.nextDateObj = data
                }
            })
        },
        goDetail (item) {
            if (item.reviewStatus === 3) {
                return
            }
            this.$router.push(`/form/detail/${item.id}/patient`)
        }
    }
}
</script>
<style lang="less" scoped>
.follow_up {
	padding: 40px 32px;

	&_null {
		text-align: center;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	&_content {
		font-size: 30px;
		min-height: 136px;
		.title {
			color: #1f2329;
		}
		.label {
			margin-top: 20px;
			color: @gray-9;
		}
		.button {
			width: 140px;
			height: 64px;
			line-height: 64px;
			border: 1px solid @primary;
			text-align: center;
			font-size: 26px;
			color: @primary;
			margin: 38px auto 0 auto;
			border-radius: 10px;
		}
	}
	&_list_item {
		padding: 32px 0;
	}
}
</style>